import panel from "@/router/asyncRoutes/admin/panel";
import product from "@/router/asyncRoutes/admin/product";
import promotion from "@/router/asyncRoutes/admin/promotion";
import order from "@/router/asyncRoutes/admin/order";
import shop from "@/router/asyncRoutes/admin/shop";
import decorate from "@/router/asyncRoutes/admin/decorate";
import salesman from "@/router/asyncRoutes/admin/salesman";
import content from "@/router/asyncRoutes/admin/content";
import finance from "@/router/asyncRoutes/admin/finance";
import user from "@/router/asyncRoutes/admin/user";
import authority from "@/router/asyncRoutes/admin/authority";
import setting from "@/router/asyncRoutes/admin/setting";

// import adminMerchant from "@/router/asyncRoutes/adminMerchant";

export default [panel, product, promotion, order, shop, decorate, salesman, content, finance, user, authority, setting];
